import React, {useState} from "react";
import Button from "@/components/button";
import css from "./index.module.scss";
import Card from "@/components/card";
import popFadeIn from "scripts/animations/popFadeIn";
import slideFadeIn from "scripts/animations/slideFadeIn";
import inViewSettings from "scripts/animations/inViewSettings";
import { useInView } from "react-intersection-observer";
import SplitText from "@/components/splitText";

export default function TestimonialsSection({
  nTestimonials = 12,
  aboutLink = false,
  className = "",
  animated = false,
}) {
  let testimonials = [
    {
      "image": "/images/portraits/manatMcleod/manatMcleod-200w",
      "quote": "I've been working with the Deviate Labs team for over a year now and it has been a fantastic experience! As our project has evolved, the team was able to adapt and optimize for each stage. Deviate Labs is a creative and resourceful team with many facets of expertise — I highly recommend their services.",
      "author": "Manat MacLeod @ SMART Technologies",
    },
    {
      "image": "/images/portraits/jennyCipoletti/jennyCipoletti-200w",
      "quote": "Deviate is incredibly thoughtful in their approach to our app's advertising strategy. They're a data-driven team that executes at a high level and provides a lot of innovative ideas. We genuinely appreciate their enthusiasm and can-do attitudes!",
      "author": "Jenny Cipoletti @ Tivvit",
    },
    {
      "image": "/images/portraits/dustinMartin/dustinMartin-200w",
      "quote": "Deviate Labs is a cutting-edge, comprehensive, and well-informed marketing company. We have been beyond impressed with their proactive nature and diligence in quickly getting our business working multiple angles that we would have otherwise not had the time for or the knowledge of. By using traditional, tried and true marketing concepts in new and technology-driven ways, they are working on a whole different level than most in their field.",
      "author": "Dustin Martin @ Martin Studios",
    },
    {
      "image": "/images/portraits/krishnaSurendra/krishnaSurendra-200w",
      "quote": "We have been working with Deviate Labs since March 2017. It started with an introductory call which lasted for 45 min. I knew that they would be the guys to help us expand our business and get more customers. Deviate Labs has been helping me with content marketing and running Google ads for our product and so far it's productive.I would recommend Deviate Labs for anyone who wants to expand their business and see a rapid growth.",
      "author": "Krishna Surendra @ HR Cloud",
    },
    {
      "image": "/images/portraits/brandonHollier/brandonHollier-200w",
      "quote": "Business consulting, in todays evolving environment, AT ITS FINEST!  Can't say enough great things about Deviate Labs and their professionals.  Extremely knowledgeable in everything business.  Whether it is a small local start up or a national organization, the team at Deviate Labs delivers custom solutions to meet specific needs. Our national company, Brush Baggy, has benefited greatly in the short amount of time we have been working with them, catapulting our reach and crafting many differential advantages that would not have had otherwise!",
      "author": "Brandon Hollier @ BrushBaggy",
    },
    {
      "image": "/images/portraits/chadThompson/chadThompson-200w",
      "quote": "Over the last year I had the pleasure of working with Deviate Labs on a variety of marketing strategies and tactics. They are a knowledgeable, forward thinking, creative team who met the unique needs of Badass Beard Care. We were extremely pleased with their ability to manage multiple projects and deliver quality content under tight deadlines. Their advanced knowledge of traditional and non-traditional marketing tactics ultimately allowed them to create and implement digital marketing strategies that had a impressive impact on influencer marketing, customer acquisition, retention and nurture flow, digital ROAS, email marketing and customer insight.",
      "author": "Chad Thompson @ Badass Beard Care",
    },
    {
      "image": "/images/portraits/dawnAnderson/dawnAnderson-200w",
      "quote": "Thank you Deviate Labs! They are wonderful to work with — 100% available, responsive, professional and data driven. Their work is over and above what I expected, always stepping up with new campaigns, suggestions to improve all things in digital marketing, not just in their domain, which as a small team, I appreciate. They have been incredibly helpful in our success. Great work Deviate!",
      "author": "Dawn Anderson @ Ohi Food Co",
    },
    {
      "image": "/images/portraits/thomasVanDerKleij/thomasVanDerKleij-200w",
      "quote": "After having gone through several marketing agencies, Deviate Labs is the first one to truly 'get' it. Most marketing agencies we worked with had their formula, which they then tried to apply to our business. Deviate Labs really looked at what was needed for our specific business and then came up with a solid combination of tried and tested channels, as well as more novel approaches. We have been hitting record after record ever since. 10/10 recommend.",
      "author": "Thomas van der Kleij @ Tapfiliate",
    },
    {
      "image": "/images/portraits/sumanPrakashDas/sumanPrakashDas-200w",
      "quote": "I have had a fantastic experience with Deviate Labs and Chad. Chad is a fantastic thinker, collaborative, and just a great team member. He and his agency are a fantastic add to the marketing engine of any company.",
      "author": "Suman Prakash Das @ Radix",
    },
    {
      "image": "/images/portraits/brian-koffler/brian-koffler-square",
      "quote": "I have been extremely impressed by Deviate Labs' ability to understand how each of my businesses functions on a very deep level.",
      "author": "Brian Koffler @ Explore + Discover",
    },
    {
      "image": "/images/portraits/paul-howey/paul-howey-square",
      "quote": "An uncanny ability to come up with insanely creative solutions to the most difficult marketing problems.",
      "author": "Paul Howey @ Talkroute",
    },
    {
      "image": "/images/portraits/ashley-harper/ashley-harper-square",
      "quote": "Deviate Labs is easy to work with... they care about how the product they are creating will benefit you.",
      "author": "Ashley Harper @ Alexander Marine USA",
    },
    {
      "image": "/images/portraits/hanna-lim/hanna-lim-square",
      "quote": "Deviate Labs' ideas for increasing traffic and sales were everything we've been looking for... I was seriously impressed.",
      "author": "Hanna Lim @ Lollaland",
    },
    {
      "image": "/images/portraits/reilly-sweetland/reilly-sweetland-square",
      "quote": "Deviate Labs helped me look at the growth of our product through a new lens.",
      "author": "Reilly Sweetland @ FollowUpThen",
    },
  ];

  testimonials = testimonials.slice(0, nTestimonials);

  const [elements, setElements] = useState({
    text: useInView(inViewSettings(slideFadeIn)),
    cards: useInView(inViewSettings(popFadeIn)),
  });

  return (
    <section className={`section ${css.testimonials} ${className}`} id="testimonials">
      <div className="sectionInner">
        <div ref={elements.text.ref}>
          <h2>
            <SplitText text="Testimonials" className="target"/>
          </h2>

          <div className={css.subheadline}>
            <SplitText text="We seek to work with passionate and driven entrepreneurs above all else. We are agnostic to the industry (in fact, we relish the opportunity to apply our innovations to new industries). Here is what some of our past clients have to say about working with us..." className="target"/>
          </div>
        </div>

        <div className={css.cards} ref={elements.cards.ref}>
          {testimonials.map((testimonial) => <Card key={testimonial.author} className="target">
            <div className={css.testimonial}>
              <picture>
                <source srcSet={`${testimonial.image}.webp`} type="image/webp"/>
                <source srcSet={`${testimonial.image}.png`} type="image/png"/>
                <img loading="lazy" src={`${testimonial.image}.png`} alt=""/>
              </picture>
              <div className={css.text}>
                <div className={css.quote}>{testimonial.quote}</div>
                <div className={css.name}>{testimonial.author}</div>
              </div>
            </div>
          </Card>)}
        </div>
        {aboutLink && <div className={css.aboutLink}>
          <Button label="Read More" href="/about/#testimonials" light ghost color="pink"/>
        </div>}
      </div>
    </section>
  );
}

